<template>
  <div class="finance-page ">
    <div class="top-bg"></div>
    <div class="top-box">
      <div class="title">{{ $t('finance.desc3') }}</div>
      <div class="sub-title">{{ $t('finance.desc4') }}</div>
      <div class="flex-start statistics-box">
        <div class="info">
          <div class="label">{{ $t('assest.label1') }}</div>
          <div class="value">{{statisticsData.Amount ? parseFloat(statisticsData.Amount).toFixed(4) : '0.0000'}}</div>
        </div>
        <!-- <div class="info">
          <div class="label">昨日收益(CNY)</div>
          <div class="value">{{statisticsData.Income ? parseFloat(statisticsData.Income).toFixed(4) : '0.0000'}}</div>
        </div> -->
        <div class="info">
          <div class="label">{{ $t('finance.label4') }}</div>
          <div class="value">{{statisticsData.Income ? parseFloat(statisticsData.Income).toFixed(4) : '0.0000'}}</div>
        </div>
      </div>

      <div class="tabs flex">
        <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{ $t('finance.tab1') }}</div>
        <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{ $t('finance.tab2') }}</div>
      </div>
    </div>

    <div class="list-table">
      <div class="th-line flex-center-between">
        <div class="th flex-3">{{ $t('transfer.label3') }}</div>
        <div class="th flex-1">{{ $t('nian-hua') }}</div>
        <div class="th flex-2">{{ $t('qi-xian-tian') }}</div>
        <div class="th action">{{ $t('cao-zuo-1') }}</div>
      </div>
      <div class="tbody">
        <div class="td-line flex-center-between" v-for="(item, i) in dataList" :key="i" >
          <div class="td flex-3 flex-center-start">
            <img :src="'/upload/' + item.Currency.Logo" alt="">
            <span>{{item.Currency.ShortName}}</span>
          </div>
          <div class="td flex-1">{{item.IncomeRatio}}%</div>
          <div class="td flex-2">{{item.ProductType == 1 ? '随存随取' : `${item.Term}天`}}</div>
          <div class="td action">
            <div class="btn" @click="toBuy(item)">{{ $t('financeBuy.btn') }}</div>
          </div>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>

    
  </div>
</template>
<script>
import { Button, List } from 'vant'
import { financeSetupList, financeList, financialStatistics, financeBuy } from '@/api/finance'
import pageBar from '@/components/pageBar'
export default {
  components: {
    Button,
    List,
    pageBar
  },
  data() {
    return {
      // emptyUrl: require('../../assets/imgs/order-empty.png'),
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      tabIndex: 1,
      finishedText: '',
      financeDataList: [], //申购产品列表
      ownerFinanceList: [], //已申购列表
      statisticsData: {},
      dataList: []
    }
  },
  mounted() {
    this.init()
    this.initStatistics()
  },
  methods: {
    changePage(page) {
      this.page.page = page
      this.init()
    },
    init() {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      financeSetupList(form).then(res => {
        if (res.data.Items) {
          let list = res.data.Items
          // .filter(v => {
          //   return v.Status == 1
          // })
          this.financeDataList = list
          this.dataList = this.financeDataList.filter(v => {
            return v.ProductType == this.tabIndex
          })
          this.totalPage = res.data.Pagination.totalPage
          if (this.totalPage <= this.page.page) {
             this.finished = true
          }
        }
        this.isInit = true
        this.loading = false

      })
    },
    initStatistics() {
      financialStatistics().then(res => {
        this.statisticsData = res.data
      })
    },
    initFinance() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      financeList().then(res => {
        this.ownerFinanceList = res.data.Items
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    toDetail(data) {
      sessionStorage.setItem('financeData', JSON.stringify(data))
      this.$router.push({
        path: '/financeDetail',
      })
    },
    toPosition() {
      this.$router.push({
        name: 'myPosition'
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.dataList = this.financeDataList.filter(v => {
        return v.ProductType == this.tabIndex
      })
      // this.init()
    },
    toBuy(data) {
      // sessionStorage.setItem('financeData', JSON.stringify(data))
      // this.$router.push({
      //   path: '/financeBuy',
      // })
      let form = new FormData()
      form.append('Amount', data.MinimumBet)
      form.append('FinancialSetupId', data.ID)
      financeBuy(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.i18n.t('financeBuy.success'))
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>